import React, { useState } from 'react';
import { Mutation } from '@apollo/client/react/components';
import { Delete, Cancel } from '@material-ui/icons';
import { IconButton, Dialog, Button, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import { DELETE_PRODUCT } from '../../../../queries/products/product';

export default function DeleteProduct({ selectedRows, products, refetch }) {
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [multiple, setMultiple] = useState(false);

  const handleCloseConfirmation = () => {
    setOpenConfirmation(false);
  };

  return (
    <Mutation
      mutation={DELETE_PRODUCT}
      update={async () => {
        await refetch();
      }}
    >
      {deleteTitle => (
        <div>
          <IconButton
            aria-label="delete"
            onClick={
                e => {
                  e.preventDefault();
                  if (selectedRows.data.length > 1) {
                    setMultiple(true);
                  } else {
                    setMultiple(false);
                  }
                  setOpenConfirmation(true);
                }
              }
          >
            <Delete />
          </IconButton>
          <Dialog
            open={openConfirmation}
            onClose={handleCloseConfirmation}
            aria-labelledby="alert-dialog-product"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-product">Are you sure?</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {
                  (multiple ? 'Do you really want to delete these Products? This process cannot be undone.' : 'Do you really want to delete this Product? This process cannot be undone.')
                }

              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseConfirmation} color="default">
                <Cancel />
                {' '}
                Cancel
              </Button>
              <Button
                onClick={() => {
                  selectedRows.data.forEach(async (product) => {
                    await deleteTitle({ variables: { id: products[product.dataIndex].id } });
                    setOpenConfirmation(false);
                  });
                }}
                color="secondary"
                autoFocus
              >
                <Delete />
                {' '}
                Delete
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      )}
    </Mutation>
  );
}
